import { SettingsManager } from "@viamap/viamap2-common"
import { MatQGL_Lib } from "./MatQGL_Lib"
import { BBRQGL_Lib } from "./BBRQGL_Lib"
import { EBRQGL_Lib } from "./EBRQGL_Lib"
import { VURQGL_Lib } from "./VURDQGL_Lib"

export class DatafordelerGQL {
  static endpoint = () => "https://" + SettingsManager.getSystemSetting("mapitServicesHost") + "/datafordelerProxy"

  static async query(query: string, register?: string) {
    let apikey = SettingsManager.getSystemSetting("mapitServicesAPIKey")
    let response = await fetch(this.endpoint(), {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-api-key": apikey || "",
      },
      body: JSON.stringify({ query: query, register: register || "flexible" }),
    })

    if (!response.ok) {
      throw new Error(`Datafordeler GQL request failed: ${response.status} ${response.statusText}`)
    }
    let data = await response.json()
    return data.data
  }

  static getSchemaURL() {
    let apikey = SettingsManager.getSystemSetting("datafordelerAPIKey")
    let params = {
      apiKey: apikey,
    }
    return this.endpoint() + "/schema?" + new URLSearchParams(params)
  }

  static Mat2 = new MatQGL_Lib(this.query.bind(this))

  static BBR = new BBRQGL_Lib(this.query.bind(this))

  static EBR = new EBRQGL_Lib(this.query.bind(this))

  static VURD = new VURQGL_Lib(this.query.bind(this))

}

// MARK: Example
// Example 
/*
await DataCollector.GQL_DataF.query(`
query {
  MAT_SamletFastEjendom(virkningstid: "2024-11-12T13:31:33z" registreringstid: "2024-11-12T13:31:33z" where: { BFEnummer: { in: [100027966, 2120920] } }
  ) {
    nodes {
      BFEnummer
      status

      jordstykkeSamlesISamletFastEjendom {
        nodes {
          status
          matrikelnummer
          jordstykkeLiggerIEjerlav {
            ejerlavskode
            ejerlavsnavn
          }
        }
      }
    }
  }
}
`
*/